require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./architecture-2-2-2-0.json") })
        }
      }, "path---architecture-2-2-2-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---architecture-2-2-2-0!./.cache/json/architecture-2-2-2-0.json
// module id = 329
// module chunks = 231608221292675